module.exports = __webpack_public_path__ + "fonts/苹方-Bold.dd25b35d.ttf";